module.exports = __webpack_public_path__ + "media/images/payment/klarna-d0843b8058b24d06ffd627d01d227b91.svg";